import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=def6e906&"
import script from "./dialogue.vue?vue&type=script&lang=js&"
export * from "./dialogue.vue?vue&type=script&lang=js&"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=def6e906&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports